"use client";

import Image from "next/image";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

// Hero Section
export function HeroSection({ title, description }: { title: string, description: string }) {
  return (
    <section className="p-2">
      <h2 className="font-bold mb-4 text-muted-foreground">{title}</h2>
      <p className="text-lg my-2 text-muted-foreground ">{description}</p>
      <hr className="my-4 text-muted-foreground" />
    </section>
  )
}
export function Card({ title, cards }: { title: string, cards: string[][] }) {
  return (
    <section className="p-2">
      <h2 className="font-bold mb-4 text-muted-foreground">{title}</h2>
      <div className="grid grid-cols-2 gap-8 p-10">
        {cards.map((card, idx) => (
          <div key={idx} className="flex flex-col gap-2 bg-secondary p-4 rounded-lg">
            <h2 className="font-bold mb-4 text-muted-foreground">{card[0]}</h2>
            <p className="text-lg my-2 text-muted-foreground ">{card[1]}</p>
          </div>
        ))}
      </div>
      
    </section>
  )
}
// Benefit List Section
export function BenefitList({ image, itemHeading, items }: { image: string, itemHeading: string, items: string[] }) {
  return (
    <section className=" mx-auto">
      <div className="grid grid-cols-2 gap-8 p-10">
        <ul className="space-y-4">

          <p className="text-lg my-2 text-muted-foreground ">{itemHeading}</p>
          <h2 className="text-3xl font-bold mb-6">Key Benefits</h2>
          {items.map((item, idx) => (
            <li key={idx} className="flex items-center gap-3 text-muted-foreground">
              <CheckCircle className="w-5 h-5 text-accent" />
              {item}
            </li>
          ))}
        </ul>
        <div className="relative w-full h-80">
          <Image src={image} alt={itemHeading} fill className="rounded-lg mx-auto" sizes="50vw" />
        </div>
      </div>
    </section>
  )
}

// Use Case Card
export function UseCaseCard({ text }: { text: string }) {
  return (
    <section className="mx-auto py-2">
      <h2 className="text-3xl font-bold mb-6">Real-World Application</h2>
      <div className="bg-secondary p-6 rounded-lg text-muted-foreground italic text-lg">{text}</div>
    </section>
  )
}
export function WhatNext({ heading, items }: { heading: string, items: string[] }) {
  return (
    <section className="py-2 mx-auto">
      <h2 className="text-3xl font-bold mb-6">{heading}</h2>
      <ul className="space-y-4">
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-3 text-muted-foreground">
            <CheckCircle className="w-5 h-5 text-accent" />
            {item}
          </li>
        ))}
      </ul>
    </section>
  )
}

export function FinalThoughts({ text1, text2 }: { text1: string, text2: string }) {
  return (
    <section className="py-3 mx-auto">
      <h2 className=" font-bold mb-6">{text1}</h2>
      <p className=" my-2 text-muted-foreground ">{text2}</p>
    </section>
  )
}
// Call To Action
export function CallToAction({ text, link }: { text: string, link: string }) {
  return (
    <div className="text-center py-16">
      <Button asChild size="lg">
        <Link href={link}>{text}</Link>
      </Button>
    </div>
  )
}
